import provinceService from '@/services/province';
import getProvinceId from '@/lib/base/getProvinceId';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    province: [],
    cities: [],
    districts: [],
  };
};
const state = initialState();

const getters = {
  province() {
    return state.province;
  },
  cities() {
    return state.cities;
  },
  districts() {
    return state.districts;
  },
  rankTypes() {
    const id = getProvinceId();
    const province = state.province.find((item) => item.id === Number(id));
    return province?.rankTypes || [];
  },
};

const actions = {
  async getProvince({commit}) {
    try {
      const result = await provinceService.getProvince();
      commit('setProvince', result);
    } catch (error) {
      this.$store.commit('env/setIsNotFound', true);
    }
  },
  async getCities({commit}, id) {
    try {
      const result = await provinceService.getCities(id);
      commit('setCities', result);
    } catch (error) {
      this.$store.commit('env/setIsNotFound', true);
    }
  },
  async getDistricts({commit}, {id, cityId}) {
    try {
      const result = await provinceService.getDistricts(id, cityId);
      commit('setDistricts', result);
      return result;
    } catch (error) {
      this.$store.commit('env/setIsNotFound', true);
    }
  },
};

const mutations = {
  setProvince(state, data) {
    state.province = data;
  },
  setCities(state, data) {
    state.cities = data;
  },
  setDistricts(state, data) {
    state.districts = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
